<template>
    <div class="grid row row-equal personal-center">
        <div class="flex xs3 md3 x3" :style="{ height: pageHeight }">
            <va-card>
                <va-card-content
                    class="ant-space ant-space-vertical ant-space-align-center"
                    style="width: 100%"
                >
                    <div class="user-photo">
                        <img :src="$store.state.profilePicture" alt="" />
                        <va-icon
                            class="icon-left input-icon"
                            name="border_color"
                            @click="amend"
                        />
                    </div>

                    <div class="ant-space ant-space-vertical">
                        <span class="head-name">{{
                            $store.state.userName
                        }}</span>
                        <div style="position: relative">
                            <span style="width: 30px; font-size: 12px"
                                >别名：</span
                            >
                            <span class="head-name">{{
                                userMsg.Alias || ""
                            }}</span>
                            <span
                                class="amend-name"
                                @click="iShowAmendName = true"
                                >修改</span
                            >
                        </div>

                        <div style="text-align: center">
                            <span class="head-title"
                                >{{ userMsg.ArticleCount }}帖子</span
                            >
                            <i style="margin: 0 10px">·</i>
                            <span class="head-title"
                                >{{ userMsg.ReplyCount }}回复</span
                            >
                        </div>
                    </div>
                </va-card-content>
                <va-card-content class="ant-row ant-row-center ant-row-top">
                    <div
                        class="ant-space ant-space-vertical flex xs6 md6 x6 ant-row-middle"
                        style="padding: 0.75rem 0"
                    >
                        <b class="integral-count"
                            >{{ creditsData.Credits
                            }}{{ userMsg.CreditCount }}</b
                        >
                        <span class="assign">积分</span>
                        <!-- <div class="user-score">积分商城</div> -->
                    </div>
                    <div
                        class="ant-space ant-space-vertical flex xs6 md6 x6 ant-row-middle"
                    >
                        <b class="integral-count">{{ userMsg.ThumbsCount }}</b>
                        <span class="assign">点赞</span>
                    </div>
                </va-card-content>
                <va-card-content
                    class="ant-space ant-space-vertical"
                    style="width: 100%; padding: 0"
                >
                    <div>
                        <a-menu
                            v-model:openKeys="openKeys"
                            v-model:selectedKeys="selectedKeys"
                            :mode="mode"
                            :theme="theme"
                        >
                            <a-menu-item key="1">
                                <template #icon>
                                    <va-icon
                                        class="icon-left input-icon"
                                        name="perm_identity"
                                    />
                                </template>
                                我的动态
                            </a-menu-item>
                            <a-menu-item key="2">
                                <template #icon>
                                    <va-icon
                                        class="icon-left input-icon"
                                        name="chat_bubble_outline"
                                    />
                                </template>
                                我的消息
                            </a-menu-item>
                            <a-menu-item key="3">
                                <template #icon>
                                    <va-icon
                                        class="icon-left input-icon"
                                        name="star_border"
                                    />
                                </template>
                                我的收藏
                            </a-menu-item>
                            <a-menu-item key="4" v-if="true">
                                <template #icon>
                                    <va-icon
                                        class="icon-left input-icon"
                                        name="card_membership"
                                    />
                                </template>
                                我的证书
                            </a-menu-item>
                        </a-menu>
                    </div>
                </va-card-content>
            </va-card>
        </div>
        <div class="flex xs9 md9 x9" :style="{ height: pageHeight }">
            <va-inner-loading
                :loading="isLoading"
                style="width: 100%"
                color="primary"
            >
                <va-card>
                    <div v-if="selectedKeys[0] == '1'">
                        <va-card-content style="padding-bottom: 0">
                            <va-tabs
                                v-model="tabValue"
                                style="width: 100%; min-width: 250px"
                                @click="tabsCLick"
                            >
                                <template #tabs>
                                    <va-tab
                                        v-for="(item, index) in tabTitles"
                                        :key="index"
                                    >
                                        {{ item.title }}
                                    </va-tab>
                                </template>
                            </va-tabs>
                        </va-card-content>
                        <va-card-content
                            :style="[
                                { height: contentHeight },
                                'overflow-y: scroll;',
                            ]"
                        >
                            <component
                                :is="tabTitlesComponentsName"
                                :push-data="replyList"
                            />
                        </va-card-content>
                    </div>
                    <div v-if="selectedKeys[0] == '2'">
                        <va-card>
                            <va-card-content
                                style="padding-bottom: 5.5px; font-size: 16px"
                                >我的消息</va-card-content
                            >
                            <va-card-content
                                :style="[
                                    { height: contentHeight },
                                    'overflow-y: scroll;',
                                ]"
                            >
                                <personalMessage
                                    :reply-list="messageData"
                                ></personalMessage>
                            </va-card-content>
                        </va-card>
                    </div>
                    <div v-if="selectedKeys[0] == '3'">
                        <va-card>
                            <va-card-content
                                style="padding-bottom: 5.5px; font-size: 16px"
                                >我的收藏</va-card-content
                            >
                            <va-card-content
                                :style="[
                                    { height: contentHeight },
                                    'overflow-y: scroll;',
                                ]"
                            >
                                <personalCollect
                                    :reply-list="replyData"
                                ></personalCollect>
                            </va-card-content>
                        </va-card>
                    </div>
                    <div v-if="selectedKeys[0] == '4'">
                        <va-card>
                            <va-card-content>
                                <va-tabs
                                    v-model="activeComponentName"
                                    grow
                                    style="width: 100%; min-width: 250px"
                                >
                                    <template #tabs>
                                        <va-tab name="certificate">
                                            RPA证书
                                        </va-tab>
                                        <va-tab name="certificatePython">
                                            Python证书
                                        </va-tab>
                                        <va-tab name="certificateAI">
                                            AI证书
                                        </va-tab>
                                    </template>
                                </va-tabs>
                            </va-card-content>
                            <component :is="activeComponentName" />
                        </va-card>
                    </div>
                    <div v-if="selectedKeys[0] != '4'">
                        <vxe-pager
                            background
                            v-model:current-page="tablePager.currentPage"
                            v-model:page-size="tablePager.pageSize"
                            :total="tablePager.totalResult"
                            @page-change="handlePageChange"
                            :layouts="[
                                'PrevJump',
                                'PrevPage',
                                'JumpNumber',
                                'NextPage',
                                'NextJump',
                                'Sizes',
                                'FullJump',
                                'Total',
                            ]"
                        ></vxe-pager>
                    </div>
                </va-card>
            </va-inner-loading>
            <vxe-modal
                title="头像修改"
                v-model="isShow"
                width="900"
                height="600"
            >
                <template #default>
                    <head-portrait @update="isUpdate"></head-portrait>
                </template>
            </vxe-modal>
            <vxe-modal title="别名修改" v-model="iShowAmendName" width="300">
                <template #default>
                    <div style="margin-right: 20px; text-align: center">
                        <vxe-input
                            clearable
                            v-model="amendName"
                            maxlength="10"
                            placeholder="请输入别名"
                            style="margin-bottom: 10px"
                        ></vxe-input>
                        <vxe-button
                            @click="setAmendName"
                            icon="fa fa-save"
                            status="success"
                        >
                            保存
                        </vxe-button>
                    </div>
                </template>
            </vxe-modal>
        </div>
    </div>
</template>
<script>
import postsMinxin from "./components/postsMinxin.js";
import { defineComponent, reactive, toRefs, ref } from "vue";
import { VXETable, VxeFormEvents, VxeFormPropTypes } from "vxe-table";
import personalReply from "./components/personalReply.vue"; //我的回复
import personalPosts from "./components/personalPosts.vue"; //我的帖子
import personalMessage from "./components/personalMessage.vue"; //我的消息
import personalCollect from "./components/personalCollect.vue"; //我的收藏
import headPortrait from "./components/headPortrait.vue"; //我的收藏
import certificate from "./components/certificate.vue"; //RPA证书
import certificatePython from "./components/certificatePython.vue"; //Python 证书
import certificateAI from "./components/certificateAI.vue"; //AI 证书

import Qs from "qs";

export default defineComponent({
    mixins: [postsMinxin],
    data() {
        const tabTitles = reactive([
            { title: "我的帖子", componentsName: "personalPosts" },
            {
                title: "回复过的帖子",
                componentsName: "personalReply",
            },
        ]);
        const tabTitlesComponentsName = ref("personalPosts");

        const state = reactive({
            mode: "inline",
            theme: "light",
            selectedKeys: ["1"],
            openKeys: ["sub1"],
        });
        const tabValue = ref(1);

        const tabsCLick = () => {
            tabTitlesComponentsName.value =
                tabTitles[tabValue.value - 1].componentsName;
        };

        return {
            amendName: "",
            iShowAmendName: false,
            creditsData: 0,
            replyList: [],
            replyData: [],
            messageData: [],
            isShow: ref(false),
            tabTitlesComponentsName,
            tabValue,
            tabsCLick,
            tabTitles,
            ...toRefs(state),
            isLoading: false,
            userMsg: {},
            activeComponentName: "certificate",
            certNames: ["certificate", "certificatePython", "certificateAI"],
            isShowPythonCer: true,
        };
    },
    mounted() {
        this.findArticle();
        // this.getUserCredits()
        this.findUserMsg();
    },
    watch: {
        tabTitlesComponentsName: function (nVal, oVal) {
            this.tablePager.currentPage = 1;
            this.tablePager.pageSize = 10;
            if (nVal == "personalPosts") {
                this.findArticle();
            } else {
                this.findReplyer();
            }
        },
        selectedKeys: function (nVal, oVal) {
            this.tablePager.currentPage = 1;
            this.tablePager.pageSize = 10;
            if (nVal[0] == 1) {
                this.findArticle();
            } else if (nVal[0] == 3) {
                this.findCollect();
            } else if (nVal[0] == 2) {
                this.findMessage();
            } else if (nVal[0] == 4) {
                this.isLoading = false;
            }
        },
    },
    components: {
        headPortrait,
        personalCollect,
        personalMessage,
        personalPosts,
        personalReply,
        certificate,
        certificatePython,
        certificateAI,
    },
    methods: {
        //别名修改
        setAmendName() {
            let params = {
                UserId: this.$store.state.userID,
                NewAlias: this.amendName,
            };
            this.$api.formsAPI
                .updateUserAlias(Qs.stringify(params))
                .then((res) => {
                    if (res.data.Success == false) {
                        VXETable.modal.message({
                            content: res.data.Message,
                            status: "warning",
                        });
                        return;
                    }
                    this.iShowAmendName = false;
                    // this.$store.commit('updateUserInfoUserRole',this.amendName);
                    this.findUserMsg();
                    VXETable.modal.message({
                        content: "别名修改成功！",
                        status: "success",
                    });
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        //获取积分
        getUserCredits() {
            let params = {
                UserId: this.$store.state.userID,
                currentPage: 1,
                pageSize: 10,
            };
            this.$api.formsAPI
                .getUserCredits(Qs.stringify(params))
                .then((res) => {
                    if (res.data.Success == false) {
                        VXETable.modal.message({
                            content: res.data.Message,
                            status: "error",
                        });
                        return;
                    }
                    this.creditsData = res.data.Data.dataTable[0];
                    // this.isLoading = false;
                    console.log(res.data.Data);
                    // this.$store.commit('updateSearchData','');
                    this.tablePager.totalResult = res.data.Data.totalResult;
                    this.tablePager.currentPage = res.data.Data.currentPage;
                    this.tablePager.pageSize = res.data.Data.pageSize;
                    // this.$emit('postsRes',res.data.Data)
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        //分页点击
        handlePageChange() {
            if (this.selectedKeys[0] == 1) {
                //我的帖子
                if (this.tabTitlesComponentsName == "personalPosts") {
                    this.findArticle();
                } else if (this.tabTitlesComponentsName == "personalReply") {
                    this.findReplyer();
                }
            } else if (this.selectedKeys[0] == 2) {
                //我的消息
                this.findMessage();
            } else if (this.selectedKeys[0] == 3) {
                //我的收藏
                this.findCollect();
            } else if (this.selectedKeys[0] == 4) {
                //证书
            }
        },
        //我回复过的帖子
        findReplyer() {
            this.isLoading = true;
            let params = {
                UID: this.$store.state.userID, // ,
                // "Creator": "",
                currentPage: this.tablePager.currentPage,
                pageSize: this.tablePager.pageSize,
            };
            this.$api.formsAPI
                .getArticleByReplyer(Qs.stringify(params))
                .then((res) => {
                    if (res.data.Success == false) {
                        VXETable.modal.message({
                            content: res.data.Message,
                            status: "error",
                        });
                        return;
                    }
                    this.replyList = res.data.Data.dataTable;
                    this.isLoading = false;
                    console.log(res.data.Data);
                    // this.$store.commit('updateSearchData','');
                    this.tablePager.totalResult = res.data.Data.totalResult;
                    this.tablePager.currentPage = res.data.Data.currentPage;
                    this.tablePager.pageSize = res.data.Data.pageSize;
                    // this.$emit('postsRes',res.data.Data)
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        //获取用户信息
        findUserMsg() {
            this.isLoading = true;
            let params = {
                UserID: this.$store.state.userID, // ,
                // "Creator": "",
                currentPage: 1,
                pageSize: 10,
            };
            this.$api.formsAPI
                .getUserInfo(Qs.stringify(params))
                .then((res) => {
                    if (res.data.Success == false) {
                        VXETable.modal.message({
                            content: res.data.Message,
                            status: "error",
                        });
                        return;
                    }
                    this.userMsg = res.data.Data.dataTable[0];
                    this.amendName = res.data.Data.dataTable[0].Alias;
                    console.log(res.data.Data.dataTable[0]);
                    this.isLoading = false;
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        //我的帖子
        findArticle() {
            this.isLoading = true;
            let params = {
                Creator: this.$store.state.userID, // ,
                // "Creator": "",
                currentPage: this.tablePager.currentPage,
                pageSize: this.tablePager.pageSize,
                Isshow: 1,
            };
            this.$api.formsAPI
                .getForumArticle(Qs.stringify(params))
                .then((res) => {
                    if (res.data.Success == false) {
                        VXETable.modal.message({
                            content: res.data.Message,
                            status: "error",
                        });
                        return;
                    }
                    this.replyList = res.data.Data.dataTable;
                    this.isLoading = false;
                    console.log(res.data.Data);
                    // this.$store.commit('updateSearchData','');
                    this.tablePager.totalResult = res.data.Data.totalResult;
                    this.tablePager.currentPage = res.data.Data.currentPage;
                    this.tablePager.pageSize = res.data.Data.pageSize;
                    // this.$emit('postsRes',res.data.Data)
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        //获取收藏数据
        findCollect() {
            this.isLoading = true;
            let params = {
                UserID: this.$store.state.userID, // ,
                // "Creator": "",
                currentPage: this.tablePager.currentPage,
                pageSize: this.tablePager.pageSize,
            };
            this.$api.formsAPI
                .getArticleCollect(Qs.stringify(params))
                .then((res) => {
                    if (res.data.Success == false) {
                        VXETable.modal.message({
                            content: res.data.Message,
                            status: "error",
                        });
                        return;
                    }
                    this.replyData = res.data.Data.dataTable;
                    this.isLoading = false;
                    console.log(res.data.Data);
                    // this.$store.commit('updateSearchData','');
                    this.tablePager.totalResult = res.data.Data.totalResult;
                    this.tablePager.currentPage = res.data.Data.currentPage;
                    this.tablePager.pageSize = res.data.Data.pageSize;
                    // this.$emit('postsRes',res.data.Data)
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        //获取我的消息
        findMessage() {
            this.isLoading = true;
            let params = {
                UserID: this.$store.state.userID, // ,
                // "Creator": "",
                currentPage: this.tablePager.currentPage,
                pageSize: this.tablePager.pageSize,
            };
            this.$api.formsAPI
                .getArticleMessage(Qs.stringify(params))
                .then((res) => {
                    if (res.data.Success == false) {
                        VXETable.modal.message({
                            content: res.data.Message,
                            status: "error",
                        });
                        return;
                    }
                    this.messageData = res.data.Data.dataTable;
                    this.isLoading = false;
                    console.log(res.data.Data);
                    // this.$store.commit('updateSearchData','');
                    this.tablePager.totalResult = res.data.Data.totalResult;
                    this.tablePager.currentPage = res.data.Data.currentPage;
                    this.tablePager.pageSize = res.data.Data.pageSize;
                    // this.$emit('postsRes',res.data.Data)
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        amend() {
            this.isShow = true;
        },
        isUpdate() {
            this.isShow = false;
        },
    },
});
</script>
<style src="../forum/css/antd.css"></style>
<style>
.inner-loading__spinner {
    -webkit-animation: va-icon--spin-animation 1.5s linear infinite;
    animation: va-icon--spin-animation 1.5s linear infinite;
    animation-direction: reverse;
}

@-webkit-keyframes va-icon--spin-animation {
    0% {
        transform: rotate(0deg);
    }

    to {
        transform: rotate(1turn);
    }
}

@keyframes va-icon--spin-animation {
    0% {
        transform: rotate(0deg);
    }

    to {
        transform: rotate(1turn);
    }
}
</style>
<style scoped lang="scss">
.amend-name {
    width: 30px;
    color: #1890ff;
    font-size: 12px;
    bottom: 0px;
    cursor: pointer;
}

.va-tab {
    font-size: 16px;
    margin: 0 10px;
}

.va-card {
    height: 100%;
}

::v-deep .va-tabs .va-tabs__container {
    border-bottom: 1px solid #ddd;
}

.personal-center {
    .user-photo {
        position: relative;

        img {
            margin-bottom: 10px;
            display: inline-block;
            vertical-align: top;
            width: 80px;
            height: 80px;

            -webkit-border-radius: 50%;
            -moz-border-radius: 50%;
            border-radius: 50%;
        }

        i {
            font-size: 20px;
            color: #9b9999ab;
            position: absolute;
            right: -17px;
            bottom: 11px;
        }
    }

    .head-name {
        margin-bottom: 10px;
        text-align: center;
        font-size: 16px;
        line-height: 16px;
        color: #262626;
    }

    .head-title {
        text-align: center;
        margin-bottom: 27px;
        font-size: 14px;
        line-height: 14px;
        color: #999;
    }

    .integral-count {
        margin-bottom: 6px;
        font-size: 22px;
        line-height: 22px;
        color: #333;
    }

    .assign {
        font-size: 13px;
        line-height: 13px;
        color: #999;
    }

    .user-score {
        display: block;
        color: #0073eb;
        margin-top: 10px;
        cursor: pointer;
    }
}
</style>
